import React from "react";
import BlogListCard from "./BlogListCard";
import { useSelector } from "react-redux";
import NoDataFound from "../../components/common/NoDataFound";
import LoadingSpinner from "../../components/common/LoadingSpinner";

const BlogList = () => {
  const BlogListData = useSelector((state) => state.blogList.BlogListData);
  const loading = useSelector((state) => state.blogList.loading);

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="col-sm-12 col-md-8">
      {!loading && !BlogListData?.Data ? (
        <NoDataFound />
      ) : (
        <>
          {BlogListData?.Data?.map((blog) => (
            <BlogListCard blog={blog} />
          ))}
        </>
      )}
    </div>
  );
};

export default BlogList;
